import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Grid, Card, Alert } from "@mui/material/";
import { QueryAPI } from "API/QueryAPI";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import { checkResponse } from "helpers/notification";
import Moment from 'moment';
import CustomExport from "components/CustomExport";
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from "react-router-dom";
import { alertSuccessText, alertWarningText } from "helpers/notification";
import axios from "axios";
import AlertNoRecordFound from "components/AlertNoRecordFound";
import AlertLoading from "components/AlertLoading";

function AlphanumericReportDetail() {

  //consts
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [list, setList] = useState(null);
  const [selectedJobEuId, setSelectedJobEuId] = useState("");
  const numberFormatter = new Intl.NumberFormat('tr-TR');
  const location = useLocation();
  const { queryId, requestParameters } = location.state || {};
  const [queryStatus, setQueryStatus] = useState(null);
  const [queryStatuses, setQueryStatuses] = useState([]);

  var groupId = useSelector(state => state.common.groupId);
  var rightFormat = useSelector(state => state.common.rightFormat);
  var authorization = useSelector(state => state.common.authorization);
  var appId = useSelector(state => state.common.appId);
  var sessionId = useSelector(state => state.common.sessionId);
  var userName = useSelector(state => state.common.userName);

  const [isLoading, setIsLoading] = useState(true);

  // functions
  const getQueryData = async () => {
    setIsLoading(true);
    setRows([]);
    setList(null);

    const getQueryDataResponse = await QueryAPI.GetQueryData(queryId, "alphanumericreport");
    if (checkResponse(getQueryDataResponse, null, "Detay Rapor getirme işlemi başarısız oldu")) {
      let res = getQueryDataResponse.data.resultObject;
      setList(res || []);
    } else {
      setList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getQueryData();
  }, [queryId]);

  useEffect(() => {
    getQueryStatuses();
  }, []);

  const getQueryStatuses = async () => {
    const response = await QueryAPI.GetQueryStatuses(queryId);
    if (checkResponse(response, null, "Detay Rapor getirme işlemi başarısız oldu")) {
      const statusQueryPairs = response.data.resultObject.statusQueryPairs;
      setQueryStatuses(statusQueryPairs);
    }
  };

  useEffect(() => {
    for (let i = 0; i < rows.length; i++) {

      let reportFileName = `${userName}_AlfanumerikDetay_${rows[i].sender}_${rows[i].acntEuId}_${rows[i].userEuId}_${Moment(rows[i].insertDate).format('YYYYMMDD')}`;

      let parameters = {
        custEuIdList: "",
        userEuId: rows[i].userEuId,
        jobEuId: null,
        sender: rows[i].sender,
        msgSpecialId: "",
        phone: null,
        startDate: JSON.parse(requestParameters).startDate,
        endDate: JSON.parse(requestParameters).endDate,
        reportFileName: reportFileName,
        groupId: groupId,
        reportType: "SenderDetail",
        rightFormat: rightFormat,
        returnValue: "OK",
        parameterUserEuIdList: rows[i].parameterUserEuIdList,
      }

      let matchingStatusQueryPair = queryStatuses.find(statusQueryPair => {
        return JSON.stringify(statusQueryPair.requestParameters) === JSON.stringify(parameters)
      }
      );

      if (matchingStatusQueryPair) {
        let linkText;

        switch (matchingStatusQueryPair.status) {
          case 0:
            linkText = "Detay Dosya Talebi Alındı";
            rows[i].linkClickable = false;
            break;
          case 1:
            linkText = "Detay Dosya Hazırlanıyor";
            rows[i].linkClickable = false;
            break;
          case 2:
            linkText = "Dosya İndir";
            rows[i].linkText = "Dosya İndir";
            rows[i].linkClickable = true;
            rows[i].linkClick = () => {
              downloadFile(matchingStatusQueryPair.id, matchingStatusQueryPair.requestParameters.reportFileName);
            };
            break;
          case 3:
            linkText = "Sorgu Sırasında Hata Alındı";
            rows[i].linkClickable = false;
            break;
          default:
            linkText = "Detay Dosya İndirme Talebi Oluştur";
            break;
        }
        rows[i].download = linkText;
      } else {
        rows[i].download = "Detay Dosya İndirme Talebi Oluştur";
        rows[i].linkClickable = true;
      }
    }

    if (queryStatuses.length > 0 && rows.length > 0) {

      let reportFileName = `${userName}_GönderimHepsi_${rows[0].sender}_${Moment(rows[0].insertDate).format('YYYYMMDD')}`;

      let parameters = {
        custEuIdList: "",
        userEuId: null,
        jobEuId: null,
        sender: JSON.parse(requestParameters).senderSelectedOptionStr,
        msgSpecialId: "",
        phone: null,
        startDate: JSON.parse(requestParameters).startDate,
        endDate: JSON.parse(requestParameters).endDate,
        reportFileName: reportFileName,
        groupId: groupId,
        reportType: "SumOfSummarySender",
        rightFormat: rightFormat,
        returnValue: "OK"
      }

      let matchingStatusQueryPair = queryStatuses.find(statusQueryPair => {
        return JSON.stringify(statusQueryPair.requestParameters) === JSON.stringify(parameters)
      }
      );

      if (matchingStatusQueryPair) {
        setQueryStatus(matchingStatusQueryPair);
      }

    }
  }, [queryStatuses, rows]);


  useEffect(() => {
    if (list === null) return;

    const createAlphanumericRowsAndColumns = async () => {
      const rowsData = [];
      if (list.length > 0) {
        list.map((data) => {
          rowsData.push({
            id: uuidv4(),
            userEuId: data.userEuId,
            acntEuId: data.acntEuId,
            sender: data.sender,
            msgCnt: numberFormatter.format(data.msgCnt),
            deliveryCount: numberFormatter.format(data.deliveryCount),
            unsentCount: numberFormatter.format(data.unsentCount),
            waitCount: numberFormatter.format(data.waitCount),
            contor: numberFormatter.format(data.contor),
            rowIndex: data.rowIndex,
            parameterUserEuIdList: data.parameterUserEuIdList,
            insertDate: data.insertDate
          });
        });
      }

      setRows(rowsData);

      setColumns([
        {
          headerName: "id", field: "id", flex: 0, hide: true, disableExport: true,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.id}
            </MDTypography>
          )
        },
        {
          headerName: "Sıra", field: "rowIndex", flex: 0.3,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.rowIndex}
            </MDTypography>
          )
        },
        {
          headerName: "Mesaj Başlığı", field: "sender", flex: 1,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.sender}
            </MDTypography>
          )
        },
        {
          headerName: "Toplam", field: "msgCnt", flex: 0.5,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.msgCnt}
            </MDTypography>
          )
        },
        {
          headerName: "Başarılı", field: "deliveryCount", flex: 0.5,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.deliveryCount}
            </MDTypography>
          )
        },
        {
          headerName: "Başarısız", field: "unsentCount", flex: 0.5,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.unsentCount}
            </MDTypography>
          )
        },
        {
          headerName: "Bekleyen", field: "waitCount", flex: 0.5,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.waitCount}
            </MDTypography>
          )
        },
        {
          headerName: "Kontör", field: "contor", flex: 0.5,
          renderCell: params => (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.contor}
            </MDTypography>
          )
        },
        {
          headerName: "İşlem", field: "download", flex: 0.5,
          renderCell: params => {
            if (!params.row.linkClickable) {
              return (
                <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                  {params.row.download}
                </MDTypography>
              );
            } else {
              return (
                <MDTypography
                  sx={style.linkStyle}
                  onClick={() => {
                    if (params.row.linkClick) {
                      params.row.linkClick();
                    } else {
                      setSelectedJobEuId(params.row.id)
                    }
                  }}
                >
                  {params.row.download}
                </MDTypography>
              );
            }
          },
        }
      ]);
      setIsLoading(false);
    };

    createAlphanumericRowsAndColumns();
  }, [list]);

  const insertQuery = async (queryType, parameters) => {

    const isExistQueryResponse = await QueryAPI.IsExistQuery(queryType, userName, parameters);
    if (isExistQueryResponse.data.resultObject.isExist) {
      alertWarningText("Talep ettiğiniz sorgu " + isExistQueryResponse.data.resultObject.queryId + " id si ile zaten var. Lütfen sorgular menüsündeki listeden kontrol ediniz.");
      return;
    }

    const insertQueryResponse = await QueryAPI.InsertQuery(
      userName,
      0,
      queryType,
      "",
      new Date(),
      parameters,
      queryId
    );
    if (
      checkResponse(
        insertQueryResponse,
        null,
        "Alfanümerik Raporu detay dosya indirme talebi, oluşturma işlemi başarısız oldu.Lütfen Tekrar deneyin."
      )
    ) {
      if (insertQueryResponse.data.resultObject !== "") {
        alertSuccessText("Sorgunuz <b>" + insertQueryResponse.data.resultObject + " </b> id si ile işleme alınmıştır.");
      }
    }
  }

  useEffect(() => {

    if (selectedJobEuId !== "") {

      let selectedRow = rows.filter(x => {
        return x.id === selectedJobEuId;
      })[0];

      let reportFileName = `${userName}_AlfanumerikDetay_${selectedRow.sender}_${selectedRow.acntEuId}_${selectedRow.userEuId}_${Moment(selectedRow.insertDate).format('YYYYMMDD')}`;

      let parameters = {
        custEuIdList: "",
        userEuId: selectedRow.userEuId,
        jobEuId: null,
        sender: selectedRow.sender,
        msgSpecialId: "",
        phone: null,
        startDate: JSON.parse(requestParameters).startDate,
        endDate: JSON.parse(requestParameters).endDate,
        reportFileName: reportFileName,
        groupId: groupId,
        reportType: "SenderDetail",
        rightFormat: rightFormat,
        returnValue: "OK",
        parameterUserEuIdList: selectedRow.parameterUserEuIdList
      }

      insertQuery("alphanumericreportdetailfile", parameters);
    }

  }, [selectedJobEuId]);

  const getWebReportTotal = async e => {

    let reportFileName = `${userName}_GönderimHepsi_${rows[0].sender}_${Moment(rows[0].insertDate).format('YYYYMMDD')}`;

    let parameters = {
      custEuIdList: "",
      userEuId: null,
      jobEuId: null,
      sender: JSON.parse(requestParameters).senderSelectedOptionStr,
      msgSpecialId: "",
      phone: null,
      startDate: JSON.parse(requestParameters).startDate,
      endDate: JSON.parse(requestParameters).endDate,
      reportFileName: reportFileName,
      groupId: groupId,
      reportType: "SumOfSummarySender",
      rightFormat: rightFormat,
      returnValue: "OK"
    }

    insertQuery("alphanumericreportdetailsumfile", parameters);
  }

  const downloadFile = async (downloadQueryId, fileName, e) => {
    window.dispatchEvent(new Event("backdropOpenStartEvent"));
    axios({
      url: process.env.REACT_APP_API_ROOT + `/Query/DownloadFile/${downloadQueryId}`,
      method: 'GET',
      responseType: 'blob', // Important
      headers: {
        Authorization: authorization,
        AppId: appId,
        SessionId: sessionId
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName + ".rar");
      document.body.appendChild(link);
      link.click();
      window.dispatchEvent(new Event("backdropOpenEndEvent"));
    });

  }

  useEffect(() => {
    const onRefresh = async () => {
      await getQueryData();
      await getQueryStatuses();
    };

    window.addEventListener("pageRefreshRequested", onRefresh);
    return () => window.removeEventListener("pageRefreshRequested", onRefresh);
  }, [queryId]);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      {
        isLoading ? (
          <AlertLoading text="Alfanümerik Rapor Yükleniyor..." />
        ) : rows.length > 0 ?
          <MDBox pt={3} pb={1}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={1}
                    px={2}
                    variant='gradient'
                    bgColor='info'
                    borderRadius='lg'
                    coloredShadow='info'
                  >
                    <MDTypography variant='h6' color='white'>
                      Alfanümerik Rapor Detayı
                    </MDTypography>
                  </MDBox>

                  <Card>
                    <MDTypography variant="h5" textAlign="center" mb={2} mt={2}>
                      <strong>Rapor Sonucu Toplam Rakamlar</strong>
                    </MDTypography>
                    <MDBox display='flex' justifyContent='space-between' px={5}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <strong>Toplam</strong>
                        </MDTypography>
                        <MDTypography variant='body2' style={{ marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <span>
                            {numberFormatter.format(list.reduce((acc, curr) => acc + curr.msgCnt, 0))}
                          </span>
                        </MDTypography>

                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <strong>Başarılı</strong>
                        </MDTypography>
                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <span>
                            {numberFormatter.format(list.reduce((acc, curr) => acc + curr.deliveryCount, 0))}
                          </span>
                        </MDTypography>

                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <strong>Başarısız</strong>
                        </MDTypography>
                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <span>
                            {numberFormatter.format(list.reduce((acc, curr) => acc + curr.unsentCount, 0))}
                          </span>
                        </MDTypography>

                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <strong>Bekleyen</strong>
                        </MDTypography>
                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <span>
                            {numberFormatter.format(list.reduce((acc, curr) => acc + curr.waitCount, 0))}
                          </span>
                        </MDTypography>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <strong>Kontör</strong>
                        </MDTypography>
                        <MDTypography variant='body2' style={{ marginRight: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                          <span>
                            {numberFormatter.format(list.reduce((acc, curr) => acc + curr.contor, 0))}
                          </span>
                        </MDTypography>

                      </div>

                      {rows.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '20px' }}>
                          {
                            queryStatus !== undefined && queryStatus !== null ? (
                              queryStatus.status === 0 ?
                                (
                                  <MDTypography
                                    sx={style.gridTextStyle}
                                    color='text'
                                    fontWeight='regular'
                                    fontSize='12px'
                                  >
                                    Detay Dosya Talebi Alındı
                                  </MDTypography>
                                )
                                : queryStatus.status === 1 ?
                                  (
                                    <MDTypography
                                      sx={style.gridTextStyle}
                                      color='text'
                                      fontWeight='regular'
                                      fontSize='12px'
                                    >
                                      Detay Dosya Hazırlanıyor
                                    </MDTypography>
                                  )
                                  : queryStatus.status === 2 ?
                                    (
                                      <MDTypography
                                        sx={style.linkStyle}
                                        onClick={() => {
                                          downloadFile(queryStatus.id, queryStatus.requestParameters.reportFileName);
                                        }}
                                      >
                                        Dosya İndir
                                      </MDTypography>
                                    )
                                    : queryStatus.status === 3 ?
                                      (
                                        <MDTypography
                                          sx={style.gridTextStyle}
                                          color='text'
                                          fontWeight='regular'
                                          fontSize='12px'
                                        >
                                          Sorgu Sırasında Hata Alındı
                                        </MDTypography>
                                      )
                                      :
                                      (
                                        <MDTypography
                                          sx={style.linkStyle}
                                          onClick={() => {
                                            getWebReportTotal();
                                          }}
                                        >
                                          Detay Dosya İndirme Talebi Oluştur
                                        </MDTypography>
                                      )
                            )
                              :
                              (
                                <MDTypography
                                  sx={style.linkStyle}
                                  onClick={() => {
                                    getWebReportTotal();
                                  }}
                                >
                                  Detay Dosya İndirme Talebi Oluştur
                                </MDTypography>
                              )
                          }
                        </div>
                      ) : ""}



                    </MDBox>
                  </Card>

                  <MDBox pt={3}>
                    <CustomExport
                      rows={rows}
                      columns={columns}
                      exportFileName={userName
                        + "_AlphanumericRaporDetay_"
                        + Moment(new Date()).format('YYYYMMDDHHmmss').toString()}
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
          :
          <AlertNoRecordFound />

      }
    </DashboardLayout>
  );
}

export default AlphanumericReportDetail;